/** Tile amarillo + teléfono rojo en círculo (historial llamadas). */
export const LLAMADA_AMARILLO = '#FFD60A';
export const LLAMADA_ICONO_STROKE = '#C53030';
export const LLAMADA_SOMBRA = '0 2px 6px rgba(255, 214, 10, 0.45)';

/** Auricular clásico (mismo trazo que acciones rápidas), escalado dentro del círculo. */
export function IconoLlamadaHistorial({ size = 22 }) {
  const stroke = LLAMADA_ICONO_STROKE;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="12" cy="12" r="10" stroke={stroke} strokeWidth="2" fill="none" />
      <g transform="translate(12 12) scale(0.5) translate(-12 -12)">
        <path
          d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z"
          stroke={stroke}
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  );
}

export function tileLlamadaHistorial(iconSize = 22) {
  return {
    accent: LLAMADA_AMARILLO,
    bg: LLAMADA_AMARILLO,
    shadow: LLAMADA_SOMBRA,
    icon: <IconoLlamadaHistorial size={iconSize} />,
  };
}

/** Formato { bg, sh, ic } usado en FichaCliente historial. */
export function tileLlamadaHistorialFicha(iconSize = 22) {
  const t = tileLlamadaHistorial(iconSize);
  return { bg: t.bg, sh: t.shadow, ic: t.icon };
}
